const STORAGE_KEY = 'ad_daily_calls'

type StoredData = {
    date: string
    counts: Record<string, number>
}

function getTodayDate(): string {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
}

function loadData(): StoredData {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (raw) {
            const parsed = JSON.parse(raw) as StoredData
            if (parsed.date === getTodayDate()) {
                return parsed
            }
        }
    } catch {
        // corrupted data, reset
    }
    return { date: getTodayDate(), counts: {} }
}

function saveData(data: StoredData): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
    } catch {
        // storage full or unavailable, silently ignore
    }
}

export function incrementDailyAdCall(adUnit: string): number {
    const data = loadData()
    data.counts[adUnit] = (data.counts[adUnit] || 0) + 1
    saveData(data)
    return data.counts[adUnit]
}
